import React, { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";
import { motion } from "framer-motion";
import Navigation from "../Navigation";
import Header from "../Header";
import {postInitEvent} from "../../../util/actions/saveCustomEvent";

const PickItemPage = ({
  page,
  setPage,
  items,
  itemIndex,
  setItemIndex,
  text,
  eventName,
  playerId,
}) => {
  const handleSelectItem = (newItemIndex) => {
    const isTheSameItemClicked = newItemIndex === itemIndex;

    if (isTheSameItemClicked) {
      return setItemIndex(undefined);
    }

    setItemIndex(newItemIndex);
  };

  useEffect(() => {
    if (playerId > 0) {
      postInitEvent(eventName,null,null,playerId)
    }
  }, [playerId]);

  return (
    <ViewContainer
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Header />
      <Content>
        <Logo>
          <img src="/assets/front/img/edustrada/logo-with-text.png" />
        </Logo>
        <TextContent>
          <Text>{text}</Text>
        </TextContent>
        <SelectBoxContainer>
          {items.map((item, index) => (
            <SelectBox
              key={index}
              onClick={() => handleSelectItem(index)}
              isSelected={index === itemIndex}
            >
              {item}
            </SelectBox>
          ))}
        </SelectBoxContainer>
        <Navigation
          showBackButton={true}
          showNextButton={itemIndex !== undefined}
          setPage={setPage}
          page={page}
          nextButtonCallback={() => {
            postInitEvent(eventName, {items: items, question: text}, {
              itemIndex: itemIndex,
              itemName: items[itemIndex]
            },playerId)
          }
          }
        />
      </Content>
    </ViewContainer>
  );
};

export default PickItemPage;

const ViewContainer = styled(motion.div)`
  min-height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const Logo = styled.div`
  display: flex;
  justify-content: center;
`;

const Content = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: 40px 0 30px 0;
`;

const Text = styled.div`
  text-align: center;
  color: #fff;
  font-size: 20px;
  line-height: 35px;
  font-weight: 300;
`;

const SmallText = styled(Text)`
  font-size: 20px;
  line-height: 25px;
`;

const SelectBoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  width: 100%;
`;

const growAnimation = keyframes`
 0% { scale: 0.9 }
 100% { scale: 1 }
`;

const SelectBox = styled.div`
  width: 100%;
  background-color: ${(props) =>
    props.isSelected ? "rgba(0, 0, 0, 0.5)" : "rgba(57,56,146,0.8)"};
  padding: 15px;
  border-radius: 15px;
  text-align: center;
  color: #fff;
  font-size: 17px;
  font-weight: 300;
  transition: all 0.2s;
  animation: ${growAnimation} 0.5s ease;

  &:active {
    transform: scale(0.97);
  }
`;
